import { createBrowserRouter, Navigate } from 'react-router-dom';
import { RootLayout } from '@/layouts/RootLayout';
import { PdvLayout } from '@/layouts/PdvLayout';
import { AdminLayout } from '@/layouts/AdminLayout';
import { SuperAdminLayout } from '@/layouts/SuperAdminLayout';
import { PdvPage } from '@/pages/pdv/PdvPage';
import { QuickModePage } from '@/pages/pdv/QuickModePage';
import { DashboardPage } from '@/pages/admin/DashboardPage';
import { ProductsPage } from '@/pages/admin/ProductsPage';
import { CustomersPage } from '@/pages/admin/CustomersPage';
import { InventoryPage } from '@/pages/admin/InventoryPage';
import { FinancialPage } from '@/pages/admin/FinancialPage';
import { ReportsPage } from '@/pages/admin/ReportsPage';
import { SettingsPage } from '@/pages/admin/SettingsPage';
import { ThemePage } from '@/pages/admin/ThemePage';
import { UsersPage } from '@/pages/admin/UsersPage';
import { AuditPage } from '@/pages/admin/AuditPage';
import { SuppliersPage } from '@/pages/admin/SuppliersPage';
import { LoyaltyPage } from '@/pages/admin/LoyaltyPage';
import { PromotionsPage } from '@/pages/admin/PromotionsPage';
import { CreditPage } from '@/pages/admin/CreditPage';
import { OrdersPage } from '@/pages/admin/OrdersPage';
import { BarRestaurantPage } from '@/pages/admin/BarRestaurantPage';
import { PriceCheckPage } from '@/pages/PriceCheckPage';
import { LoginPage } from '@/pages/LoginPage';
import { SuperAdminLoginPage } from '@/pages/super-admin/SuperAdminLoginPage';
import { SuperAdminDashboardPage } from '@/pages/super-admin/SuperAdminDashboardPage';
import { TenantsPage } from '@/pages/super-admin/TenantsPage';
import { TenantDetailPage } from '@/pages/super-admin/TenantDetailPage';
import { TenantCreatePage } from '@/pages/super-admin/TenantCreatePage';
import { PlansPage } from '@/pages/super-admin/PlansPage';
import { AnnouncementsPage } from '@/pages/super-admin/AnnouncementsPage';
import { RegistrationRequestsPage } from '@/pages/super-admin/RegistrationRequestsPage';
import { SubscriptionBlockedPage } from '@/pages/SubscriptionBlockedPage';
import { OnboardingPage } from '@/pages/onboarding/OnboardingPage';
import { StorePage } from '@/pages/store/StorePage';
import { OrderTrackingPage } from '@/pages/store/OrderTrackingPage';
import { SlugLoginPage } from '@/pages/SlugLoginPage';

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      {
        path: '/',
        element: <Navigate to="/login" replace />,
      },
      {
        path: '/pdv',
        element: <PdvLayout />,
        children: [
          {
            index: true,
            element: <PdvPage />,
          },
          {
            path: 'quick',
            element: <QuickModePage />,
          },
        ],
      },
      {
        path: '/admin',
        element: <AdminLayout />,
        children: [
          {
            index: true,
            element: <Navigate to="/admin/dashboard" replace />,
          },
          {
            path: 'dashboard',
            element: <DashboardPage />,
          },
          {
            path: 'products',
            element: <ProductsPage />,
          },
          {
            path: 'customers',
            element: <CustomersPage />,
          },
          {
            path: 'inventory',
            element: <InventoryPage />,
          },
          {
            path: 'financial',
            element: <FinancialPage />,
          },
          {
            path: 'reports',
            element: <ReportsPage />,
          },
          {
            path: 'settings',
            element: <SettingsPage />,
          },
          {
            path: 'theme',
            element: <ThemePage />,
          },
          {
            path: 'users',
            element: <UsersPage />,
          },
          {
            path: 'audit',
            element: <AuditPage />,
          },
          {
            path: 'suppliers',
            element: <SuppliersPage />,
          },
          {
            path: 'loyalty',
            element: <LoyaltyPage />,
          },
          {
            path: 'promotions',
            element: <PromotionsPage />,
          },
          {
            path: 'credit',
            element: <CreditPage />,
          },
          {
            path: 'orders',
            element: <OrdersPage />,
          },
          {
            path: 'bar-restaurant',
            element: <BarRestaurantPage />,
          },
        ],
      },
      {
        path: '/login',
        element: <LoginPage />,
      },
      // Public store routes (no auth required)
      {
        path: '/loja/:slug',
        element: <StorePage />,
      },
      {
        path: '/loja/:slug/pedido/:orderId',
        element: <OrderTrackingPage />,
      },
      // Super Admin routes
      {
        path: '/super-admin/login',
        element: <SuperAdminLoginPage />,
      },
      {
        path: '/super-admin',
        element: <SuperAdminLayout />,
        children: [
          {
            index: true,
            element: <Navigate to="/super-admin/dashboard" replace />,
          },
          {
            path: 'dashboard',
            element: <SuperAdminDashboardPage />,
          },
          {
            path: 'tenants',
            element: <TenantsPage />,
          },
          {
            path: 'tenants/new',
            element: <TenantCreatePage />,
          },
          {
            path: 'tenants/:id',
            element: <TenantDetailPage />,
          },
          {
            path: 'plans',
            element: <PlansPage />,
          },
          {
            path: 'requests',
            element: <RegistrationRequestsPage />,
          },
          {
            path: 'announcements',
            element: <AnnouncementsPage />,
          },
        ],
      },
      // Subscription blocked
      {
        path: '/subscription-blocked',
        element: <SubscriptionBlockedPage />,
      },
      // Price check (standalone)
      {
        path: '/consulta',
        element: <PriceCheckPage />,
      },
      // Onboarding
      {
        path: '/onboarding',
        element: <OnboardingPage />,
      },
      // Slug login (MUST be last to avoid catching other routes)
      {
        path: '/:slug',
        element: <SlugLoginPage />,
      },
    ],
  },
]);
